import {Schemas} from "./Schemas";
import {Template} from "./Template";
import {Colors} from "./Colors";
import {AppConfig} from "./AppConfig";

export class App {

    id: string;
    name: string;
    description: string;
    path: string;
    url: string;
    logo: string;
    bgImage: string;
    facebookLink: string;
    twitterLink: string;
    linkedinLink: string;
    instagramLink: string;
    tikTokLink: string;
    template: Template;
    schemas: Schemas;
    payment: any;
    messages: any;
    config: AppConfig;
    autoOpenOnFormPage: number;

    constructor() {
        this.id = "";
        this.name = "";
        this.description = "";
        this.path = "";
        this.url = "";
        this.logo = "";
        this.bgImage = "";
        this.facebookLink = "";
        this.twitterLink = "";
        this.linkedinLink = "";
        this.instagramLink = "";
        this.tikTokLink = "";
        this.autoOpenOnFormPage = 0;
        this.template = new Template(new Colors("", ""));
        this.config = new AppConfig(false, false, 0);
        this.schemas = new Schemas();
    }

}
